module.exports = __webpack_public_path__ + "static/media/tennisweb.b50802c0.jpeg";